<template>
  <div class="website-external-wrapper">
    <AppHeader
      :key="Math.random()"
      :hide-menu="true"
      :no-animate="noAnimate"
      v-if="$route.name === 'home'"
    ></AppHeader>


    <div
      class="website-container"
    >

      <WebContainer
        :site-content="siteContent"
      ></WebContainer>

      <div class="surveys-wrapper delay-entry delay-more delay-even-more delay-like-crazy" v-if="surveyFridge">
        <router-link
          :to="`/s/${key}/0?utm_source=web&utm_medium=referral`"
          v-for="(survey, key) in surveyFridge"
          v-if="survey.ogImage"
          :key="key"
          class="survey-item"
        >
          <div class="item-wrapper" v-if="surveyFridge"
            @click="redirectIfSet(survey)"
          >
            <div class="image"
              :style="{backgroundImage: `url(${survey.ogImage.fields.file.url})`}"
              v-if="survey.ogImage && survey.ogImage.fields && survey.ogImage.fields.file"
            ></div>
            <div class="text">
              <h2>{{survey.ogTitle}}</h2>
              <p>{{survey.ogDescription}}</p>
              <div class="cta mobile">
                <el-row>
                  <el-button
                    class="delay-entry cta-button"
                    :class="{'alt-color': survey.shortcodeTakeThisTest}"
                    type="danger"
                    round
                  >{{survey.shortcodeTakeThisTest || 'Tomar el test'}}</el-button>
                </el-row>
              </div>
            </div>

            <div class="cta desktop">
              <el-row>
                <el-button
                  class="delay-entry cta-button"
                  :class="{'alt-color': survey.shortcodeTakeThisTest}"
                  type="danger"
                  round
                >{{survey.shortcodeTakeThisTest || 'Tomar el test'}}</el-button>
              </el-row>
            </div>
          </div>
        </router-link>
      </div>

      <WebContainer
        :site-content="siteContent2"
      ></WebContainer>

      <div class="powered-by-wrapper">
        <a href="https://www.sensata.io/" target="_blank" class="powered-item delay-entry delay-more delay-even-more delay-like-crazy"><img src="https://images.ctfassets.net/23j2jgn7jrsr/6T0PLi9OWttVcOTc5MPKUz/5aa6eab93947fb4bc6ab2589069d40b4/sensata-logo.svg" style="max-width:150px;width:100%;" alt="Powered by Sensata" /></a>
        <a href="https://www.contentful.com/" rel="nofollow" target="_blank" class="powered-item"><img src="https://images.ctfassets.net/fo9twyrwpveg/44baP9Gtm8qE2Umm8CQwQk/c43325463d1cb5db2ef97fca0788ea55/PoweredByContentful_LightBackground.svg" style="max-width:100px;width:100%;" alt="Powered by Contentful" /></a>
        <div class="small-text">
          This site is protected by reCAPTCHA and the Google
              <a href="https://policies.google.com/privacy">Privacy Policy</a> and
              <a href="https://policies.google.com/terms">Terms of Service</a> apply.          
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from 'Core/src/api/index'
import Vue from 'vue'

export default {
  name: 'Home',

  transition: 'page',

  props: [ 'bgImage', 'noAnimate' ],

  components: {
    AppHeader: () => import('LocalComponents/AppHeader'),
    WebContainer: () => import('LocalComponents/WebContainer'),
    Icons: () => import('Components/base/Icons')
  },

  data () {
    return {
      refs: [],
      content: {}
    }
  },

  computed: {
    siteContent () {
      if (this.$store.state.surveyRefs && this.$store.state.surveyRefs.fields)
      return this.$store.state.surveyRefs.fields.webContent || {}
    },
    siteContent2 () {
      if (this.$store.state.surveyRefs && this.$store.state.surveyRefs.fields)
      return this.$store.state.surveyRefs.fields.webContent2 || {}
    },
    shortcode () {
      return this.$route.params.shortcode
    },
    surveyFridge () {
      return this.$store.state.surveyFridge
    },
  },

  mounted () {
    this.$store.dispatch('LOAD_SURVEY_REFS')
      .then(async r => {
        var keys = Object.keys(r.fields.publicRefs)
        await keys.forEach(key => {
          this.$store.dispatch('LOAD_NEW_SURVEY', { surveyId: r.fields.refs[key] })
        })
        setTimeout(() => {
          window.scrollTo(0, 0);
        }, 999)
        setTimeout(() => {
          if (this.shortcode && r.fields.refs[this.shortcode]) {
            this.$router.push(`/s/${r.fields.refs[this.shortcode]}/0`)
          }
        }, 1000)
      })
  },

  methods: {
    redirectIfSet (survey) {
      if (survey.redirect) {
        window.location = survey.redirect
      }
    }
  },

  metaInfo () {
    var fbAppID = process.env.VUE_APP_FACEBOOK_APP_ID
    return {
      title: 'testeame  | ¿Ahora qué quieres hacer?',
      meta: [
        { 'property': 'og:url', 'content': 'https://testeame.com', 'vmid': 'og:url'},
        { 'property': 'og:image:width', 'content': '1200', 'vmid': 'og:image:width'},
        { 'property': 'og:image:height', 'content': '1200', 'vmid': 'og:image:height'},
        { 'property': 'og:image:type', 'content': 'image/jpeg', 'vmid': 'og:image:type'},
        { 'property': 'og:type', 'content': 'website', 'vmid': 'og:type'},
        { 'property': 'og:title', 'content': 'testeame | ¿Ahora qué quieres hacer?', 'vmid': 'og:title'},
        { 'property': 'og:description', 'content': 'Aprende y conéctate con otros. ¡Tests, encuestas de opinión y juegos en los que aprendes y te diviertes!', 'vmid': 'og:description'},
        { 'property': 'twitter:description', 'content': 'Aprende y conéctate con otros. ¡Tests, encuestas de opinión y juegos en los que aprendes y te diviertes!', 'vmid': 'twitter:description'},
        { 'property': 'og:image', 'content': 'https://testeame.com/img/icons/testeame-og-1200.png', 'vmid': 'og:image'},
        { 'property': 'twitter:image', 'content': 'https://testeame.com/img/icons/testeame-og-1200.png', 'vmid': 'twitter:image'},
        { vmid: "fb:app_id", property: "fb:app_id", content: fbAppID },
        { vmid: "og:type", property: "og:type", content: 'website' }
      ]

    }
  }
}
</script>

<style scoped lang="scss">
.powered-by-wrapper {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  padding: 1em;
  background-color: $gray-light;
  flex-wrap: wrap;
}
.desktop {
  display: none !important;
  @include breakpoint($tablet) {
    display: flex !important;
  }
}
.mobile {
  display: block;
  @include breakpoint($tablet) {
    display: none !important;
  }
}
.website-container {
  padding-top: 60px;
  margin-top: 0px !important;
}
.surveys-wrapper {
  max-width: 400px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 0.4em;
  @include breakpoint($tablet) {
    max-width: 800px;
    margin-top: 0.3em;
  }
}
.survey-item {
  margin-bottom: 0.5em;
  border-radius: 5px;
  border: 1px solid $gray-light;
  padding: 0.5em;
  background: white;
  transition: background-color 0.2s ease-in-out;
  display: flex;
  flex-direction: column;
  text-decoration: none;
  text-align: left;
  margin-bottom: 1em;
  margin-top: 1em;
  padding: 1em 0.5em;
  p {
    color: $text-main;
  }
  @include breakpoint($tablet) {
    margin-bottom: 0.3em;
    margin-bottom: 1em;
    margin-top: 1em;
    padding: 0.5em;
  }
  .item-wrapper {
    display: flex;
    flex-direction: row;    
  }
  .image {
    display: block;
    width: 35%;
    height: 0;
    padding-bottom: 35%;
    margin-right: 0.5em;
    background-size: cover;
    @include breakpoint($tablet) {
      width: 20%;
      padding-bottom: 20%;
    }
  }
  .text {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    text-align: left;
    font-size: 0.9em;
    width: 100%;
    p {
      margin-bottom: 0;
      width: 100%;
    }
    h2, h4 {
      color: $color-wrapper-emphasis-lighter !important;
      width: 100%;
      font-size: 16px;
    }
    @include breakpoint($tablet) {
      font-size: 0.8em;
    }
  }
  .cta {
    flex: 1;
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 1em;
    width: 100%;
    @include breakpoint($tablet) {
      margin-top: 0;
      justify-content: center;
      align-items: center;
    }
  }
}
.cta-button {
  min-width: 160px;  
  @include breakpoint($tablet) {
    min-width: 200px;  
  }
}
.small-text {
  margin-top: 1em;
  font-size: 12px;
  text-align: left;
  @include breakpoint($tablet) {
    text-align: right;
    max-width: 300px;
  }
}
</style>
<style lang="scss">
.website-external-wrapper,
.website-container {
  min-height: calc(100vh - 50px) !important;
}
.website-external-wrapper .website-container {
  h4 {
    color: $color-wrapper-emphasis-lighter !important;
  }
}
.website-external-wrapper {
  .cta-button.alt-color {
    background: $color-wrapper-marine !important;
    border-color: $color-wrapper-marine !important;
    &:hover,
    &:focus {
      background: $color-wrapper-marine-darker !important;
      border-color: $color-wrapper-marine-darker !important;
    }
  }
}
</style>